export enum USER_DEPARTMENT_CODE {
    DEPARTMENT_1 = 'd1',
    DEPARTMENT_2 = 'd2',
    LOGISTICS_SUPPORT = '60 18 00 13',
    INFORMATION_CENTER = '60 18 11',
    TECHNICAL_SOLUTIONS = '60 18 12',
    TECHNICAL_OPERATIONS = '60 18 13',
    QUALITY_PERFORMANCE = '60 18 14',
    EXECUTIVE_OFFICE = '60 18 15'
}

export enum SECTION_CODES {
    QUALITY_ASSURANCE = '60 18 14 11',
    LOGISTICS_SUPPORT = '60 18 00 13'
}

export enum USER_DEPARTMENT_CODE_COOKIE {
    DEPARTMENT_1 = 'd1',
    DEPARTMENT_2 = 'd2',
    LOGISTICS_SUPPORT = '60-18-00-13',
    INFORMATION_CENTER = '60-18-11',
    TECHNICAL_SOLUTIONS = '60-18-12',
    TECHNICAL_OPERATIONS = '60-18-13',
    QUALITY_PERFORMANCE = '60-18-14',
    EXECUTIVE_OFFICE = '60-18-15'
}
